import { useEffect, useState } from "react";
import { IDLE_TIMEOUT_MS } from "./config";

export function useIdle(onIdle: () => void, paused: boolean) {
  useEffect(() => {
    if (paused) return;
    let id = window.setTimeout(onIdle, IDLE_TIMEOUT_MS);
    const reset = () => { window.clearTimeout(id); id = window.setTimeout(onIdle, IDLE_TIMEOUT_MS); };
    const events: (keyof WindowEventMap)[] = ["pointerdown", "touchstart", "keydown", "input", "click"];
    events.forEach((event) => window.addEventListener(event, reset, { passive: true }));
    return () => { window.clearTimeout(id); events.forEach((event) => window.removeEventListener(event, reset)); };
  }, [onIdle, paused]);
}

export function useTypewriter(text: string, active: boolean) {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (!active) {
      const reset = window.setTimeout(() => setValue(""), 0);
      return () => window.clearTimeout(reset);
    }
    let position = 0;
    const timer = window.setInterval(() => {
      position += 1; setValue(text.slice(0, position));
      if (position >= text.length) window.clearInterval(timer);
    }, 19);
    return () => window.clearInterval(timer);
  }, [active, text]);
  return value;
}

export const haptic = (pattern: number | number[] = 12) => navigator.vibrate?.(pattern);
